import type { CanvasStepTypeView } from '../../../api/client.ts';

const CATEGORIES = ['Message Controls', 'Flow Controls', 'Audience Updates'] as const;

/** Step types by category (Braze palette); a click adds the step at the chosen place or as a free step. */
export function Palette({ types, target, disabled, onPick }: { types: CanvasStepTypeView[]; target: string; disabled: boolean; onPick: (type: CanvasStepTypeView) => void }) {
  return (
    <nav className="canvas-palette" aria-label="Steps">
      <p className="hint">{target}</p>
      {CATEGORIES.map((category) => {
        const items = types.filter((t) => t.category === category);
        if (items.length === 0) return null;
        return (
          <section key={category} aria-label={category}>
            <h3>{category}</h3>
            {items.map((t) => (
              <button key={t.type} type="button" className="canvas-palette__item" disabled={disabled} title={t.description} onClick={() => onPick(t)}>
                {t.label}
                {!t.runtime && <span className="hint"> · preview</span>}
              </button>
            ))}
          </section>
        );
      })}
    </nav>
  );
}
